export enum QuestionType {
  termFirst,
  definitionFirst,
  random,
  showAll,
}
